var editHardware = (function () {
    const init = function () {
      $("#edit-hardware-button").on("click", function () {
        const viewModel = {
          Id: $("#Id").val(),
          Version: $("#Version").val(),
          Description: $("#Description").val(),
        };
  
        $.ajax({
          url: "/Hardwares/Edit",
          method: "POST",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(viewModel),
        }).done(function (data) {
          if (data.success) {
            $.notificationSuccess(data.header, data.message);
            setTimeout(function () {
              document.location = "/Hardwares/Index";
            }, reloadDelay);
          } else {
            $.notificationAlert(data.header, data.message);
          }
        });
      });
    };
  
    return {
      init: init,
    };
  })();
  